import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FvtFilters from '../widgets/FvtFilters';

const Fvt = () => {
    return (
        <>
            <Header />
            <div style={{ padding: '1rem', margin: '0 auto', maxWidth: '1200px' }}>
                <h1>Page FVT</h1>
                <p>Bienvenue sur la page FVT.</p>
                <FvtFilters />
            </div>
            <Footer />
        </>
    );
};

export default Fvt;